import { toCurrencyNumber } from '@/util/format';

// 活動 description 由管理後台 ActivityEditor 以 JSON.stringify([對象描述, 此活動備註]) 存入；
// 舊資料可能是純文字，解析失敗時整段視為對象描述。
export function parseActivityDescription(description) {
  if (!description) {
    return { target: '', note: '' };
  }
  try {
    const data = JSON.parse(description);
    if (Array.isArray(data)) {
      return { target: data[0] || '', note: data[1] || '' };
    }
  } catch (e) {
    // 非 JSON：沿用原字串
  }
  return { target: String(description), note: '' };
}

// 活動鐘點總計（price）顯示文字；後端未回傳時為空字串
export function activityPriceText(price) {
  if (price === undefined || price === null || price === '') {
    return '';
  }
  return toCurrencyNumber(price);
}
